import { render, staticRenderFns } from "./addExcellence.vue?vue&type=template&id=56ad2f36&scoped=true"
import script from "./addExcellence.vue?vue&type=script&lang=js"
export * from "./addExcellence.vue?vue&type=script&lang=js"
import style0 from "./addExcellence.vue?vue&type=style&index=0&id=56ad2f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ad2f36",
  null
  
)

export default component.exports